export default __webpack_public_path__ + "static/media/Order-Pending.79bf4f2d.jpg";